var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrid = function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.798 4.8v4.8h4.8V4.8zm-1.2-1.2h7.2v7.2h-7.2V3.6m1.2 10.8v4.8h4.8v-4.8zm-1.2-1.2h7.2v7.2h-7.2v-7.2m15.6-8.4h-4.8v4.8h4.8zm-4.8-1.2h6v7.2h-7.2V3.6zm0 10.8v4.8h4.8v-4.8zm-1.2-1.2h7.2v7.2h-7.2v-7.2"
  })));
};
export default SvgGrid;